module.exports = __webpack_public_path__ + "img/hair_back_male_afro_mask.7b031507.png";